module.exports = __webpack_public_path__ + "media/annarbor.ac7cfde9.mp4";